// Lightweight hook so components can reliably know when auth status is loaded.
import { useEffect, useState } from "react";
import { subscribeAuth, getAuthUser } from "./authGate";
import type { User } from "firebase/auth";

export function useAuthUser(): User | null {
  const [u, setU] = useState<User | null>(() => getAuthUser());
  useEffect(() => subscribeAuth(setU), []);
  return u;
}

export function useIsAuthed(): boolean {
  return !!useAuthUser();
}

// BACK‑COMPAT: legacy callers imported useAuthReady; since we removed the "undefined" phase
// readiness is immediate (auth is either a cached user or null). Return true so builds succeed.
export function useAuthReady(): boolean {
  return true;
}
